import React from 'react';
import { CONFIG } from '../data/assets';
import styles from './Header.module.css';

export default function Header({ activeTab, onTabChange }) {
  return (
    <header className={styles.header}>
      <div className={styles.topbar}>
        <div className={styles.left}>
          {/* Replace the src below with your actual PRC logo path once in production */}
          <div className={styles.logoBox}>PRC</div>
          <div className={styles.divider} />
          <div className={styles.titleBlock}>
            <span className={styles.title}>Hours Request</span>
            <span className={styles.subtitle}>Pacific Rim Capital · Lease Administration</span>
          </div>
        </div>
        <div className={styles.meta}>
          <div className={styles.metaItem}>
            <span className={styles.metaLabel}>Client</span>
            <span className={styles.metaVal}>{CONFIG.client}</span>
          </div>
          <div className={styles.metaItem}>
            <span className={styles.metaLabel}>Lease</span>
            <span className={styles.metaVal}>{CONFIG.lease}</span>
          </div>
          <div className={styles.metaItem}>
            <span className={styles.metaLabel}>Due</span>
            <span className={styles.duePill}>{CONFIG.dueDate}</span>
          </div>
        </div>
      </div>
      <nav className={styles.tabs}>
        <button
          className={`${styles.tab} ${activeTab === 'form' ? styles.tabActive : ''}`}
          onClick={() => onTabChange('form')}
        >
          Hours Entry
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'tracker' ? styles.tabActive : ''}`}
          onClick={() => onTabChange('tracker')}
        >
          Activity Tracker
        </button>
      </nav>
    </header>
  );
}
